import {zoomIdentity, ZoomTransform} from 'd3'

//Liste des mode 
export const dataLimitMode = {
    ALL:'ALL',
    LAST_12H:'LAST_12H',
    LAST_24H:'LAST_24H'
}
Object.freeze(dataLimitMode)

export class GraphUiState {

    public typeUiid:string
    public refresh:boolean
    public variableX:string
    public variableY:string
    public variableColor:string
    public transform:ZoomTransform
    public zoom:string
    public pointSize:number
    public useVoronoi:boolean
    public colorSingle:string
    public colorMin:string
    public colorMid:string
    public colorMax:string
    public custDomainX:Array<number>|null
    public custDomainY:Array<number>|null
    public custDomainColor:Array<number>|null
    public dataLimit:string
    public autoScaleX:boolean
    public autoScaleY:boolean
    public gliderIdx:number

    constructor({                
                typeUiid="detail", //detail ou global
                refresh=false,
                variableX="GPCTD_TEMPERATURE",
                variableY="GPCTD_PRESSURE",
                variableColor="None",
                transform=zoomIdentity,
                zoom="ZoomXAxis",
                pointSize=2,
                useVoronoi=false,
                colorSingle="",
                colorMin="#2c7bb6",
                colorMid="#ffff8c",
                colorMax="#d7191c",
                custDomainX=null,
                custDomainY=null,
                custDomainColor=null,
                dataLimit=dataLimitMode.LAST_12H,
                autoScaleX=false,
                autoScaleY=false,
                gliderIdx=0
            } = {}) {  
        this.typeUiid = typeUiid
        this.refresh = refresh
        this.variableX = variableX
        this.variableY = variableY
        this.variableColor = variableColor
        this.transform = transform
        this.zoom = zoom     
        this.pointSize = pointSize
        this.useVoronoi = useVoronoi 
        this.colorSingle = colorSingle
        this.colorMin = colorMin
        this.colorMid = colorMid
        this.colorMax = colorMax
        this.custDomainX = custDomainX
        this.custDomainY = custDomainY
        this.custDomainColor = custDomainColor
        this.dataLimit = dataLimit
        this.autoScaleX = autoScaleX
        this.autoScaleY = autoScaleY
        this.gliderIdx = gliderIdx
    }
}